import { createSlice } from '@reduxjs/toolkit';

export interface InvitationState {
  body: string;
  subject: string;
  extension: string;
  meetingName: string;
}

const initialState: InvitationState = {
  body: '',
  subject: '',
  extension: '',
  meetingName: ''
};

const invitationSlice = createSlice({
  name: 'invitationState',
  initialState,
  reducers: {
    resetInvitation() {
      return initialState;
    },
    updateInvitation(state, { payload }) {
      return {
        body: payload.body,
        subject: payload.subject,
        extension: payload.extension,
        meetingName: payload.meetingName
      };
    }
  }
});

export const { resetInvitation, updateInvitation } = invitationSlice.actions;
export default invitationSlice.reducer;
